
import { defineComponent } from 'vue'
import EditModeButtons from './EditModeButtons.vue'

export default defineComponent({
  components: { EditModeButtons },
  props: {
    editModeAllowed: { type: Boolean, default: true },
    editMode: { type: Boolean, default: false }
  },
  emits: ['createFolderClicked', 'switchEditModeClicked', 'searchTriggered'],
  methods: {
    variablesButtonRowClasses() {
      return {
        'variables-buttons-row-edit': this.editMode
      }
    },
    changeSearchQueryHandler(e: Event) {
      this.$emit('searchTriggered', e)
    }
  }
})
